<script setup>
import { computed, ref } from 'vue';
const $props = defineProps({
  value: [Number, String],
    max: [Number, String],
    theme: String,
    showPercentage: Boolean,
    showValue: Boolean,
    r: {
      type: [Number, String],
      default: 100
    },
    size: {
      type: String,
      default: 'normal'
    },
    title: String
})

const classes = computed(() => ({
  'k-progress-circle': true,
  'progress-circle': true
}))
const computedMax = computed(() => parseInt($props.max) || 100)
const computedBox = computed(() => {
  const radius = parseInt($props.r)
  const plus = $props.size === 'thin' ? 3 : 6
  return {
    x: radius + plus,
    y: radius + plus,
    r: radius
  }
})
const circleStyle = computed(() => {
  const radius = parseInt($props.r)
  const percentage = $props.value / computedMax.value
  return {
    strokeDasharray: `calc(${radius}px * 3.14159 * 2 * ${percentage}), calc(${radius}px * 3.14159 * 2 * ${1 - percentage})`
  }
})


</script>

<template>
  <div :class="classes">
      <div class="progress">
        <div class="content">
          <slot><p>{{ title }}</p></slot>
        </div>
        <svg ref="svg" :width="computedBox.x * 2" :height="computedBox.x * 2">
          <circle
            :class="{ thin: $props.size === 'thin' || null }"
            :cx="computedBox.x "
            :cy="computedBox.y"
            :r="computedBox.r"
          />
          <circle
            :style="circleStyle"
            :class="{ thin: $props.size === 'thin' || null, [`theme--${$props.theme}`]: !!$props.theme }"
            :cx="computedBox.x"
            :cy="computedBox.y"
            :r="computedBox.r"
          />
        </svg>
      </div>
    </div>
</template>
